import { ScaleLinear } from "d3";
import { useMemo } from "react";

import { Action, FrameStencil } from "../../../types";
import { getActionMaxTime, getActionMinTime } from "../utils/index";

interface UseBarConstraintsProps {
  action: Action;
  frameStencils: FrameStencil[];
  scale: ScaleLinear<number, number>;
}

interface UseBarConstraints {
  prevMaxTime: number;
  nextMinTime: number;
}

export const useBarConstraints = ({ action, frameStencils, scale }: UseBarConstraintsProps): UseBarConstraints =>
  useMemo((): { prevMaxTime: number; nextMinTime: number } => {
    const domain = scale.domain();

    const prevMaxTime = getActionMinTime({ action, frameStencils, startTime: domain[0] || 0 });
    const nextMinTime = getActionMaxTime({ action, frameStencils, endTime: domain[1] || 0 });

    return { prevMaxTime, nextMinTime };
  }, [frameStencils, action, scale]);
